import { Injector } from '@angular/core';

export enum ManagementResource {
  Patient = 'patient',
  Appointment = 'appointment',
  TreatmentPlan = 'treatmentPlan',
  TreatmentStep = 'treatmentStep',
  Invoice = 'invoice',
  MarketingCampaign = 'marketingCampaign',
  MarketingCampaignRun = 'marketingCampaignRun',
  MarketingCampaignEntry = 'marketingCampaignEntry',
  Brand = 'brand',
  Practice = 'practice',
  Staffer = 'staffer',
  CustomReport = 'customReport',
  ReportRun = 'reportRun',
  WithRef = 'withRef',
  Data = 'data',
}

export interface IRelatedResource<T> {
  resource: ManagementResource;
  value: T;
}

export interface IManagementResource<T = unknown> {
  name: string;
  label: string;
  icon: string;
  resource: ManagementResource;
  hideInSidebar?: boolean;
  typeGuard: (value: unknown) => value is T;
  resolveLabel: (value: T, injector: Injector) => string;
  resolveRelated?: (value: T) => Promise<IRelatedResource<unknown>[]>;
  uniqueBy?: (value: T) => string;
}
